import * as React from 'react'
import { useLnRouterTrial } from '../../../../auth/plans/useLnRouterTrial';
import UserTrialAd from './UserTrialAd';
import UserSubscriptionAd from './UserSubscriptionAd';
import { useLnRouterAuth } from '../../../../auth/useLnRouterAuth';

type Props = {
  onClose?: () => any
}



const UserUnsubscriptionAd: React.FC<Props> = ({ onClose }) => {
  const trial = useLnRouterTrial();
  

  if (trial.loading) {
    return <React.Fragment />
  }

  if (trial.available) {
    return <UserTrialAd onClose={onClose} />
  } else {
    return <UserSubscriptionAd onClose={onClose}/>
  }
}

export default UserUnsubscriptionAd;

